import {GetStaticProps} from 'next';
import React from 'react';
import {AnimatedHeaderText} from 'ui/components/AnimatedHeaderText';

const ANIMATION_DURATION = 3000;

const TEXT = `Spaces that make you ha>>><|ppy`;

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      disablePushNotificationManager: true,
    },
  };
};

const Fiddle: React.FC = () => {
  return (
    <div style={{padding: '40px'}}>
      <h1 className="rwe-h1">
        <AnimatedHeaderText>{TEXT}</AnimatedHeaderText>
      </h1>
      <h2 className="rwe-h2">
        <AnimatedHeaderText>{TEXT}</AnimatedHeaderText>
      </h2>
      <h3 className="rwe-h3">
        <AnimatedHeaderText>{TEXT}</AnimatedHeaderText>
      </h3>
      <h4 className="rwe-h4">
        <AnimatedHeaderText>{TEXT}</AnimatedHeaderText>
      </h4>
    </div>
  );
};

export default Fiddle;
